import classnames from 'classnames';
import CommentIcon from '~/assets/images/docviewer/comment.svg?react';
import { formatTimestamp, formats } from '~/helpers/dateHelper';

type TDocViewerAddedNoteProps = {
  note: any;
}

const DocViewerAddedNote = (props: TDocViewerAddedNoteProps) => {

  const { note } = props;

  // Notes near the bottom of the page should expand upward on hover
  // to avoid being clipped by the parent container's overflow: hidden
  const isNearBottom = note.topPc > 65;

  const noteStyle: React.CSSProperties = {
    position: 'absolute',
    top: isNearBottom ? 'auto' : `${note.topPc}%`,
    bottom: isNearBottom ? `${100 - note.topPc - (note.heightPc || 5)}%` : 'auto',
    left: `${note.leftPc}%`,
    width: '200px',
  };

  const cssClass = classnames(
    'doc-viewer-note',
    'user-select-none',
  );

  return (
    <div
      className={cssClass}
      style={noteStyle}
    >
      <div className="doc-viewer-note-body">
        <div className="doc-viewer-note-icon-wrapper">
          <CommentIcon className="doc-viewer-note-icon" />
        </div>
        <div className="doc-viewer-note-content">
          {(note.user?.userFullName || note.userFullName) && <div className="doc-viewer-note-user">{note.user?.userFullName || note.userFullName}</div>}
          <div className="doc-viewer-note-text">{note.text}</div>
          {note.createdTs && <div className="doc-viewer-note-date">{formatTimestamp(note.createdTs, formats.US_DATE)}</div>}
        </div>
      </div>
    </div>
  );
};

export default DocViewerAddedNote;
